<div class="header">
    <h2>{{ 'quiz-questions.modal.add.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="quiz-questions-add-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'quiz-questions.form.questionText' | translate }}</h2>
        <app-form-input
            label
            [control]="form.controls.questionText"
            [placeholder]="'quiz-questions.form.questionText.placeholder' | translate"
            inputId="questionText"
            testId="quiz-questions-add-question-text"
        />
    </div>

    <div class="section">
        <h2>{{ 'quiz-questions.fieldset.answers' | translate }}</h2>
        @for (answer of answers.controls; track $index) {
            <app-quiz-answer
                [control]="answer"
                [index]="$index"
                [correctAnswer]="correctAnswer"
                [canRemove]="answers.length > 1"
                [testId]="'quiz-questions-answer-' + $index"
                (remove)="removeAnswer($index)"
            />
        }
        <p-button
            [label]="'quiz-questions.form.answer.add' | translate"
            icon="pi pi-plus"
            [outlined]="true"
            severity="secondary"
            data-test="quiz-questions-add-answer-add"
            (onClick)="addAnswer()"
        />
    </div>
</form>

<div class="footer">
    <p-button
        [label]="'quiz-questions.form.cancel' | translate"
        [outlined]="true"
        severity="secondary"
        data-test="quiz-questions-add-cancel"
        (onClick)="close()"
    />
    <p-button
        type="submit"
        [label]="'quiz-questions.form.create' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="quiz-questions-add-submit"
        (onClick)="onSubmit()"
    />
</div>
